export interface SegmentOption {
  value: string;
  label: string;
}

export const SegmentTiles = ({
  options,
  value,
  onChange,
  disabled = false,
  amountStyle = false,
  ariaLabel,
}: {
  options: SegmentOption[];
  value: string | null;
  onChange: (value: string) => void;
  disabled?: boolean;
  amountStyle?: boolean;
  ariaLabel: string;
}) => (
  <div className="give-segment" role="radiogroup" aria-label={ariaLabel}>
    {options.map((option) => {
      const selected = value === option.value;
      return (
        <button
          key={option.value}
          type="button"
          role="radio"
          aria-checked={selected}
          disabled={disabled}
          className={`give-segment__option${selected ? ' give-segment__option--selected' : ''}${
            amountStyle ? ' give-segment__option--amount' : ''
          }`}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      );
    })}
  </div>
);
